// extracted by mini-css-extract-plugin
module.exports = {"form":"choose-role_form__aNtzH","rolesContainer":"choose-role_rolesContainer__Gp1WK"};